// extracted by css-extract-rspack-plugin
export default {"content":"content-HfkOyo","sampleList":"sampleList-msKITw","sampleLink":"sampleLink-JSDwId","pageTitle":"pageTitle-RW7lHR","sectionTitle":"sectionTitle-ksVz4p"};